import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { RightOffClear } from "./offcanvas";
import { ClearImages } from "./attachments";
import {
  // CashoutSlice,
  updateRequest,
} from "./cashouts";

const AGentsSlice = createSlice({
  name: "agents",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    AGentsStart: (state) => {
      state.loading = true;
    },
    AGentsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    AGentsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { AGentsStart, AGentsSuccess, AGentsFailure } =
  AGentsSlice.actions;

export const AgentResponce = (data) => async (dispatch) => {
  try {
    dispatch(AGentsStart());
    const response = await axios.put(`/private/cashout`, data);
    if (response?.status === 201) {
      dispatch(AGentsSuccess(response.data));
      dispatch(RightOffClear());
      dispatch(ClearImages(response.data));
      dispatch(updateRequest(response.data));
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(AGentsFailure(errorMessage));
  }
};
export const AgentGetResponce = (data) => async (dispatch) => {
  try {
    dispatch(AGentsStart());

    const response = await axios.post(`/private/rejectcash`, data);
    if (response?.status === 201) {
      dispatch(AGentsSuccess(response.data));
      dispatch(RightOffClear());
      dispatch(ClearImages(response.data));
      dispatch(updateRequest(response.data));
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(AGentsFailure(errorMessage));
  }
};

export default AGentsSlice.reducer;
